import React from 'react'

export const Hit = ({ hit }) => {
  return (
    <tbody data-testid={`hit-product-${hit.ProductId}`}>
      <td data-testid={`hit-product-name-${hit.ProductId}`}>
        {hit.ProductName}
      </td>
    </tbody>
  )
}
